<script lang="ts">
	import Katex from './Katex.svelte';
	import uqnSplit from './functions/uqnSplit';
	import signAssign from './functions/signAssign';
	import fractionBuilder from './functions/fractionBuilder';
	//import Fraction from './functions/fractionClass';
	import polyBuilder from './functions/polyBuilder';
	//import brackets from './functions/brackets';

	export let uqn: number;

	let qn: string;
	$: [qn] = uqnToQn(uqn);

	function uqnToQn(u:number):string[]{
		let [t,i,a,b,c,s] = uqnSplit(u);
		if (t==1){ // f(x)
			let q: string;
			if (i<4){ // perfect square cases
				let num: string, den: string;
				if (i<2){
					num = b.toString();
				} else{
					num = polyBuilder([b],"x",1);
				}
				if (i%2==0){
					den = polyBuilder([1,0,a*a],"x",2,false);
				} else{
					den = polyBuilder([1,0,-a*a],"x",2,false);
				}
				q = fractionBuilder(num,den);
			} else if (i==4){ // complete square case
				[a,b] = signAssign(s,a,b);
				q = fractionBuilder(1,polyBuilder([1,a,b],"x",2,false));
			} else if (i==5){
				q = "\\cos^2 (" + polyBuilder([a],"x",1) + ")";
			} else if (i==6){
				q = "\\sin^2 (" + polyBuilder([a],"x",1) + ")";
			}
			q = `\\displaystyle ${fractionBuilder("\\mathrm{d}y","\\mathrm{d}x")} = ${q}`;
			return [q];
		} else if (t==2){ // f(y)
			let yPoly: string
			if (i<3){ // 0: a + by, 1: sqrt(a+by), 2: (a+by)^2/3
				if (i==2){ // cuberoot
					[a,b] = signAssign(s,a,b);
					yPoly = polyBuilder([a,b],"y");
					yPoly = `( ${yPoly} )^{\\frac{2}{3}}`;
				} else if (i==1){ // sqrt
					[a,b] = signAssign(s,a,b);
					yPoly = polyBuilder([a,b],"y");
					yPoly = `\\sqrt{ ${yPoly} }`;
				} else{ // i = 0: a+by
					yPoly = polyBuilder([a,-b],"y");
				}
			} else if (i==3 || i==4){ // perfect squares
				let sign = 1;
				if (i==4){
					sign = -1;
				}
				yPoly = polyBuilder([a*a,0,sign*b*b],"y")
			} else if (i==5){ // complete square
				[a,b] = signAssign(s,a,b);
				yPoly = polyBuilder([-b,-a,-1],"y");
			} else{ // e^ay
				yPoly = `e^{ ${polyBuilder([a],"y",1)} }`;
			}
			const q = `\\displaystyle ${fractionBuilder("\\mathrm{d}y","\\mathrm{d}x")} = ${yPoly}`;
			return [q]
		} else if (t==3){ // d2ydx2 = f(x)
			[a,b,c] = signAssign(s,a,b,c);
			// values for i==0: d2ydx2 = a
			let q = a.toString();
			if (i==1){ // a+bx
				q = polyBuilder([a,b]);
			} else if (i==2){ // e^ax
				q = `e^{${polyBuilder([a],"x",1)}}`;
			} else if (i==3) { // cos ax
				q = `\\cos (${polyBuilder([a],"x",1)})`;
			} else if (i==4) { // sin ax
				q = `\\sin (${polyBuilder([a],"x",1)})`;			
			}
			q = `\\displaystyle \\frac{\\mathrm{d}^2y}{\\mathrm{d}x^2} = ${q}`
			return [q];
		}
	}
</script>

<p class="qnpart">
	<Katex math={qn}/>
</p>


